module.exports = __webpack_public_path__ + "img/example10.7a0b18c5.jpg";